export const faqItems = [
  {
    q: '山頂視角 PEAKVIEW 出版哪些類型的書？',
    a: '山頂視角 PEAKVIEW 以商業理財、政治與以古諷今類人文社科書籍為主要出版方向，涵蓋商業思考、經濟與社會、政治與社會、歷史與政治及公共議題等知識閱讀內容。',
  },
  {
    q: '山頂視角 PEAKVIEW 適合哪些讀者？',
    a: '適合關注商業理財、政治、歷史、社會趨勢與人文內容，希望透過閱讀理解制度、權力與當代議題的讀者。',
  },
  {
    q: '山頂視角 PEAKVIEW 和崧博出版是什麼關係？',
    a: '本品牌委託崧博出版經銷，官方網站由崧博出版製作。山頂視角不是崧博旗下品牌、子品牌或自有品牌。',
  },
  {
    q: '山頂視角 PEAKVIEW 和財經錢線有什麼不同？',
    a: '財經錢線較偏商業理財、職場與現代生活觀察；山頂視角 PEAKVIEW 則涵蓋商業理財、政治與以古諷今類人文社科書籍，重視制度觀察、歷史經驗與公共議題的閱讀視角。',
  },
  {
    q: '什麼是以古鑑今或以古諷今？',
    a: '以古鑑今或以古諷今，是透過歷史事件、人物、思想與制度，連結並理解當代社會與公共議題，觀察不同時代之間可能存在的相似結構與邏輯。',
  },
];

export const newBooks2026 = [
  {
    id: 1,
    title: '非對稱戰爭',
    subtitle: '衝突中的小國決策：以弱抗強的戰爭抉擇？',
    author: '[加]馬林科·波維奇 著 / 徐無 譯',
    theme: '政治與社會',
    description:
      '從伊拉克、摩爾多瓦到塞爾維亞，解析後冷戰時代非對稱衝突的政治邏輯。小國為何拒絕屈從強權？在戰敗風險中尋求政治生存。',
    coverUrl:
      'https://storage.helloreaddy.io/project_files/d7679676-dd63-4051-b8b6-c3731369aef5/bb3174fc-e27b-469b-8ed9-f3b97e794299_compressed_9786267940013.webp',
    catalogUrl: 'https://catalog.sonbook.net/',
  },
  {
    id: 2,
    title: '用聖人標準寫奏摺，用賤人思維謀利益',
    author: '張鳴 著',
    theme: '以古諷今',
    description:
      '從繩子到西裝，滿朝文武都在演。張鳴以筆為刀，剖開朝代更迭中換湯不換藥的戲碼。',
    coverUrl:
      'https://storage.helloreaddy.io/project_files/d7679676-dd63-4051-b8b6-c3731369aef5/18d8505b-6787-4d58-8c1c-3082f4555990_compressed_9786267709993.webp',
    catalogUrl: 'https://catalog.sonbook.net/',
  },
  {
    id: 3,
    title: '別處生活',
    subtitle: '二十幅平民肖像',
    author: '晏禮中 著',
    theme: '人文社科',
    description:
      '一人一世界，走進時代的另一面。晏禮中以二十幅平民肖像，呈現那些最熟悉卻最容易被忽視的普通人的生活、掙扎與尊嚴。',
    coverUrl:
      'https://storage.helloreaddy.io/project_files/d7679676-dd63-4051-b8b6-c3731369aef5/db8a8fd7-e020-4823-a733-0f19ca0e42b2_compressed_9786267709948_3D_72dpi.webp',
    catalogUrl: 'https://catalog.sonbook.net/',
  },
  {
    id: 4,
    title: '先別急著賣東西，新手業務的十二堂必修課',
    author: '徐書俊 著',
    theme: '商業理財',
    description:
      '從滾出去到簽下去，終身受用的銷售技巧。徐書俊以十二堂必修課，帶領新手業務告別業績焦慮。',
    coverUrl:
      'https://storage.helloreaddy.io/project_files/d7679676-dd63-4051-b8b6-c3731369aef5/c4533d6a-76ea-4c16-8347-50f481a8985a_compressed_9786267709931_3D_72dpi.webp',
    catalogUrl: 'https://catalog.sonbook.net/',
  },
  {
    id: 5,
    title: '皇權操盤手',
    subtitle: '這樣造反最划算！',
    author: '趙心姚 著',
    theme: '以古諷今',
    description:
      '從趙高到李世民，破解奪權者的決策架構與效益分析。政變就像做生意，看誰更狠更精準。',
    coverUrl:
      'https://storage.helloreaddy.io/project_files/d7679676-dd63-4051-b8b6-c3731369aef5/0da2bee3-e5e2-4fce-9f03-75e4ae8f0ac7_compressed_9786267709924_3D_72dpi.webp',
    catalogUrl: 'https://catalog.sonbook.net/',
  },
  {
    id: 6,
    title: '道士上山',
    subtitle: '最當代的道士採訪實錄',
    author: '晏禮中 著',
    theme: '人文社科',
    description:
      '走訪天南地北，見證形形色色的修行。修無用、修止語、修一口氣——看似遙遠的大道，或許藏在最簡單的日常裡。',
    coverUrl:
      'https://storage.helloreaddy.io/project_files/d7679676-dd63-4051-b8b6-c3731369aef5/a316e766-077b-494b-ba3d-5530a54dd5e1_compressed_9786267709771_3D_72dpi.webp',
    catalogUrl: 'https://catalog.sonbook.net/',
  },
  {
    id: 7,
    title: '養到破產為止，中華歷代帝國的官僚養成實錄',
    author: '張鳴 著',
    theme: '以古諷今',
    description:
      '沒人想亡國，但大家都在混。張鳴以筆為刀，剖開歷代政權的慢性自殺——統治不需要理解，只需要服從。',
    coverUrl:
      'https://storage.helloreaddy.io/project_files/d7679676-dd63-4051-b8b6-c3731369aef5/9aae2271-2eb4-4e1f-b252-e8f7ce95c122_compressed_9786267709870_3D_72dpi.webp',
    catalogUrl: 'https://catalog.sonbook.net/',
  },
  {
    id: 8,
    title: '內鬥慣性',
    subtitle: '中國人的身分焦慮與集體否定',
    author: '張鳴 著',
    theme: '以古諷今',
    description:
      '從歷史、權力與羞恥感看互害文化的運作邏輯。沒了外敵，他們就內鬥——自我否定成了最沉重的文化枷鎖。',
    coverUrl:
      'https://storage.helloreaddy.io/project_files/d7679676-dd63-4051-b8b6-c3731369aef5/657a78e2-78e4-4289-ad6f-0ee3d01adad5_compressed_9786267709856_3D_72dpi.webp',
    catalogUrl: 'https://catalog.sonbook.net/',
  },
  {
    id: 9,
    title: '柳宗元',
    subtitle: '唐代最會講道理的官',
    author: '陳為人 著',
    theme: '以古諷今',
    description:
      '不為官職低頭，被貶也要當清流。他以文筆為劍，寫出千年政德——唐代「官為民役」第一人柳宗元。',
    coverUrl:
      'https://storage.helloreaddy.io/project_files/d7679676-dd63-4051-b8b6-c3731369aef5/5d6543f8-ee46-49c6-b336-d5a6e29fec72_compressed_9786267709788_3D_72dpi.webp',
    catalogUrl: 'https://catalog.sonbook.net/',
  },
];